var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.contact)?_c('div',[_vm._v(" "+_vm._s(_vm.contact.name)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }